import React from 'react';
import styled from 'styled-components';

const WalletManagementStyle = styled.div`
  .wallet-heading {
    margin-bottom: 32px;
    h3 { font-size: 1.5rem }
  }

  /* Side-by-side info cards */
  .cards-row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 20px;
    margin-bottom: 36px;
  }

  .info-card {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
    padding: 18px 24px;
    border-radius: 12px;
    border: 1px solid #e0e0e0;
    background: #fafafa;
    min-width: 240px;

    .card-media img { width: auto; height: 52px; object-fit: contain; }

    .card-body-info {
      display: flex;
      flex-direction: column;
      gap: 2px;

      .card-label {
        font-size: 0.8rem;
        color: #888;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }
      .card-value {
        font-size: 1.4rem;
        font-weight: 700;
        line-height: 1.2;
        small { font-size: 0.8rem; font-weight: 400; color: #888; }
      }
      .card-sub {
        font-size: 0.78rem;
        color: #999;
        margin-top: 2px;
      }
    }
  }

  /* Edit section */
  .edit-section {
    display: none;
  }

  .last-transactions {
    .heading {
      font-size: 1.5rem;
      margin-bottom: 20px;
    }
    
    table thead tr th { min-width: 175px !important; }
  }
`;

export default WalletManagementStyle;
